// @ts-strict-ignore
import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { FieldOption } from './FieldOption';

export class FileFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<API.FileComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent, reservedIds: Array<string>): boolean {
    const isReserved = !!reservedIds.find(id => id === component.id);
    if (component.type !== 'FILE' || isReserved) {
      return false;
    }

    const hasContentTypes =
      !!(component as API.FileComponent).acceptedContentTypes &&
      !!this.component.acceptedContentTypes;

    if (hasContentTypes) {
      return (
        this.component.acceptedContentTypes[0] === 'image/*' &&
        (component as API.FileComponent).acceptedContentTypes[0] === 'image/*'
      );
    } else {
      return (
        !!(component as API.FileComponent).acceptedContentTypes ===
        !!this.component.acceptedContentTypes
      );
    }
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }
}
